module.exports = __webpack_public_path__ + "static/pinkfairymain-6a283f84dcbc6262c1a47c01745a8a58.png";